// extracted by mini-css-extract-plugin
export default {"cls1":"Reason-cls1_znE","cls2":"Reason-cls2_yY0 Reason-cls1_znE"};